import { render, staticRenderFns } from "./dataAgreementMain.vue?vue&type=template&id=b3285f2e&"
import script from "./dataAgreementMain.vue?vue&type=script&lang=js&"
export * from "./dataAgreementMain.vue?vue&type=script&lang=js&"
import style0 from "./dataAgreementMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports